class AccordionProduct {
  constructor(containerSelector, btnSelector) {
    this.container = document.querySelector(containerSelector);
    this.btnSelector = document.querySelector(btnSelector);
    this.dynamicPrice = this.btnSelector.querySelectorAll('.dynamic-price');
    
    if (!this.container) {
      console.error("Accordion container not found!");
      return;
    }
    this.init();
  }

  init() {
    this.radioButtons = this.container.querySelectorAll('input[type="radio"][name="b1g1_selector"]');
    this.bindEvents();
    this.updateAllDynamicPrices();
  }

  bindEvents() {
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", (event) => this.onRadioChange(event));
    });
  }

  onRadioChange(event) {
    const selectedRadio = event.target;
    const selectedValue = selectedRadio.value; 
    const selectedId = selectedRadio.id;
    const accordions = this.container.querySelectorAll(".accordion-col");

    accordions.forEach((accordion) => {
      const variantPicker = accordion.querySelector(".product_info_container");
      const radio = accordion.querySelector(`input[type="radio"]`);

      if (radio.id === selectedId) {
        variantPicker.style.display = "block";
      } else {
        variantPicker.style.display = "none";
      }
    });

    if (this.dynamicPrices) {
      this.dynamicPrices.forEach((priceElement, index) => {
        if (index === Array.from(this.radioButtons).indexOf(selectedRadio)) {
          priceElement.textContent = selectedValue;
        }
      });
    }

    this.formButtonChecker(selectedId);
  }

  updateAllDynamicPrices() {
    if (this.dynamicPrice) {
      this.radioButtons.forEach((radio, index) => {
        if (this.dynamicPrice[index]) {
          this.dynamicPrice[index].textContent = radio.value;
        }
      });
    }
  }

  formButtonChecker(selectedId){
    console.log(selectedId);
    if(selectedId == "b1g1_unchecked"){
      document.querySelector("#b1g1_not_form").style.display = "block";
      document.querySelector("#b1g1_form").style.display = "none";
    }else{
      document.querySelector("#b1g1_not_form").style.display = "none";
      document.querySelector("#b1g1_form").style.display = "block";
    }
  }
}

// Instantiate the Accordion class

new AccordionProduct(".default-banner-accord", ".variant_tabs");


document.addEventListener('variant:change', function(event) {
  new AccordionProduct(".default-banner-accord", ".variant_tabs");
  
  let target = event.target; // The element that triggered the event
  let form = target.closest("form"); // Find the closest parent form
  let formId = form.attributes.id.nodeValue;
  let public_title = event.detail.variant.public_title;

  if (formId == "b1g1_top" || formId == "b1g1") {
      let var_picker = document.querySelector(`[form-id="${formId}"]`);
      var_picker.querySelector(".variant-picker__option-info span").textContent = public_title;
  } else {
      console.log("No parent form found.");
  }
});


